<template>
<div>
  <div class="card">
    <div class="card-header">
      <h4 class="card-title">Configurações de Eventos</h4>
    </div>
    <div class="card-content">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <p class="category">
              Os eventos terão <strong>cerimônia?</strong>
            </p>
            <p-switch
              v-model="project.event.hasCeremony"
              type="primary"
              on-text="Sim"
              off-text="Não"
            ></p-switch>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <p class="category">
              A <strong>substituição</strong> do cliente sorteado será:
            </p>
            <p-radio
              inline
              v-model="project.event.automaticReplacement"
              label="true"
            >Automática
            </p-radio>
            <p-radio
              inline
              v-model="project.event.automaticReplacement"
              label="false"
            >Manual
            </p-radio>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <p class="category">
              A <strong>data</strong>
              de recebimento no <strong>protocolo de entrega</strong>
              (termo de entrega) será manual ou automática?
            </p>
            <p-radio
              inline
              v-model="project.event.autoDateOnDeliveryTerm"
              label="true"
            >Automática
            </p-radio>
            <p-radio
              inline
              v-model="project.event.autoDateOnDeliveryTerm"
              label="false"
            >Manual
            </p-radio>
          </div>
        </div>
      </div>
      <div class="form-group">
        <p class="category">
          Será permitido <strong>sortear cliente já contemplados</strong>
          anteriormente?
        </p>
        <p-radio
          inline
          name="eventCustomersCanBeRecontemplated"
          v-model="project.event.customersCanBeRecontemplated"
          label="true"
        >Sim
        </p-radio>
        <p-radio
          inline
          name="eventCustomersCanBeRecontemplated"
          v-model="project.event.customersCanBeRecontemplated"
          label="false"
        >Não
        </p-radio>
      </div>
      <div class="form-group">
        <p class="category">
          <strong>Por quantos anos</strong> os clientes
          <strong>serão</strong> considerados como
          <strong>contemplados?</strong>
        </p>
        <input
          type="number"
          name="contemplatedPeriod"
          v-validate="validations.event.contemplatedPeriod"
          v-model.number="project.event.contemplatedPeriod"
          class="form-control"
        >
        <small
          class="text-danger"
          v-show="validations.event.contemplatedPeriod.invalid"
        >
          {{ getError('contemplatedPeriod') }}
        </small>
      </div>

      <div class="form-group">
        <p class="category">
          Haverá <strong>envio de fotos</strong> no evento?
        </p>
        <YesNoRadio v-model="project.event.hasPhotos"></YesNoRadio>
      </div>

      <div class="form-group">
        <p class="category">
          Haverá <strong>cadastro de clientes via planilha</strong>?
        </p>
        <p-radio
          inline
          name="eventManagedCsv"
          v-model="project.event.managedCsv"
          label="true"
        >Sim
        </p-radio>
        <p-radio
          inline
          name="eventManagedCsv"
          v-model="project.event.managedCsv"
          label="false"
        >Não
        </p-radio>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import PSwitch from 'src/components/UIComponents/Switch.vue'
import YesNoRadio from '../YesNoRadio'

export default {
  name: 'EventsConfigForm',

  components: {
    PSwitch,
    YesNoRadio
  },

  computed: {
    ...mapGetters('project', ['validations']),
    project: {
      get () {
        return this.$store.state.project.one
      }
    }
  },

  methods: {
    getError (fieldName) {
      return this.errors.first(fieldName)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Trg/Project/EventsConfigForm.vue